export default "__VITE_ASSET__7SZRt$l3__"